import React from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import ResetPassword from "../../CcpSchool/CcpSchoolAccountProfile/inc/ResetPassword";
import UserProfileRequest from "../../CcpSchool/CcpSchoolAccountProfile/inc/UserProfileRequest";

const DistrictAccountInfo = ({ open, onClose, schoolName }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>Account Info</ModalDialogTitle>
      <DialogContent>
        {/* Add your account info content here */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <ResetPassword />
          </Grid>
          <Grid item xs={12} md={6}>
            <UserProfileRequest schoolName={schoolName} />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DistrictAccountInfo;
